import * as effects from 'redux-saga/effects';
import { IAdvertisementRadioActionTypes } from './Types';
import {
  getAdvertisementRadio,
  getAdvertisementRadioFailure,
  getAdvertisementRadioSuccess,
} from './Actions';
import { Backend } from '../../Backend/Backend';

function* handleGetAdvertisementRadio(
  action: ReturnType<typeof getAdvertisementRadio>
) {
  const backend = Backend.getInstance();
  try {
    const result = yield effects.apply(backend, backend.getRadioAd, [
      action.payload,
    ]);
    if (result) {
      // todo implement verification result is AdResult
      yield effects.put(getAdvertisementRadioSuccess(result));
    } else {
      throw new Error('response is not a result');
    }
  } catch (err) {
    if (err instanceof Error) {
      yield effects.put(getAdvertisementRadioFailure(err.message));
    } else if (typeof err === 'string') {
      yield effects.put(getAdvertisementRadioFailure(err));
    } else {
      yield effects.put(getAdvertisementRadioFailure('Unknown error occurred'));
      console.log(err);
    }
  }
}

function* watchAdvertisementRadio() {
  yield effects.takeEvery(
    IAdvertisementRadioActionTypes.GET_AD_RADIO,
    handleGetAdvertisementRadio
  );
}

export function* AdvertisementRadioSaga() {
  yield effects.all([effects.fork(watchAdvertisementRadio)]);
}
